import { useState } from 'react'
import TitleScreen from './screens/TitleScreen'
import HomeScreen from './screens/HomeScreen'
import GamePlayScreen from './screens/GamePlayScreen'
import ResultScreen from './screens/ResultScreen'
import FreeModeSelectionScreen from './screens/FreeModeSelectionScreen'
import FlashcardScreen from './screens/FlashcardScreen'

function App() {
  const [screen, setScreen] = useState('title')
  const [gameMode, setGameMode] = useState(null)
  const [questionRange, setQuestionRange] = useState(null)
  const [freeModeIsRandom, setFreeModeIsRandom] = useState(false)
  const [gameResult, setGameResult] = useState(null)
  const [gameSessionKey, setGameSessionKey] = useState(0)

  const renderScreen = () => {
    switch (screen) {
      case 'title':
        return <TitleScreen onStart={() => setScreen('home')} />

      case 'home':
        return (
          <HomeScreen
            onSelectMode={(mode) => {
              setGameMode(mode)
              if (mode === 'free') {
                setQuestionRange(null)
                setScreen('free-selection')
              } else if (mode === 'flashcard') {
                setQuestionRange(null)
                setScreen('flashcard')
              } else if (mode === 'weak') {
                // 苦手問題モード - 直接ゲームプレイへ
                setQuestionRange(null)
                setGameSessionKey(prev => prev + 1)
                setScreen('gameplay')
              } else {
                setQuestionRange(null)
                setGameSessionKey(prev => prev + 1)
                setScreen('gameplay')
              }
            }}
          />
        )

      case 'free-selection':
        return (
          <FreeModeSelectionScreen
            variant="free"
            onConfirmRange={(range, isRandom) => {
              setQuestionRange(range)
              setFreeModeIsRandom(isRandom)
              setGameSessionKey(prev => prev + 1)
              setScreen('gameplay')
            }}
            onBack={() => {
              setQuestionRange(null)
              setFreeModeIsRandom(false)
              setScreen('home')
            }}
          />
        )

      case 'flashcard':
        return (
          <FlashcardScreen
            questionRange={questionRange}
            onExit={() => setScreen('home')}
          />
        )

      case 'gameplay':
        return (
          <GamePlayScreen
            key={gameSessionKey}
            mode={gameMode}
            questionRange={questionRange}
            freeModeIsRandom={freeModeIsRandom}
            onComplete={(result) => {
              setGameResult(result)
              setScreen('result')
            }}
            onExit={() => setScreen('home')}
          />
        )

      case 'result':
        return (
          <ResultScreen
            result={gameResult}
            onContinue={() => setScreen('home')}
            onRetry={() => {
              setGameSessionKey(prev => prev + 1)
              setScreen('gameplay')
            }}
          />
        )

      default:
        return <TitleScreen onStart={() => setScreen('home')} />
    }
  }

  return (
    <div className="w-full h-full">
      {renderScreen()}
    </div>
  )
}

export default App
